var _circle, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListNewNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#FFEE8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99997,
    cy: 6,
    r: 3.88889,
    fill: "#FF4343"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7793_1330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4461 30.8329H21.1128V25.2773H19.7239V30.8329H15.5572V25.2773H14.1683V30.8329C14.1683 31.2013 14.3147 31.5545 14.5751 31.815C14.8356 32.0755 15.1889 32.2218 15.5572 32.2218H29.4461C29.8145 32.2218 30.1677 32.0755 30.4282 31.815C30.6887 31.5545 30.835 31.2013 30.835 30.8329V25.2773H29.4461V30.8329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4674 19.2148L30.6341 13.5482C30.5191 13.3168 30.3418 13.122 30.1222 12.9859C29.9026 12.8497 29.6494 12.7775 29.391 12.7773H15.6132C15.3548 12.7775 15.1016 12.8497 14.882 12.9859C14.6624 13.122 14.4852 13.3168 14.3702 13.5482L11.5368 19.2148C11.4401 19.4089 11.3902 19.623 11.391 19.8398V21.9787C11.3904 22.3033 11.5034 22.6177 11.7104 22.8676C12.0165 23.2184 12.3944 23.4992 12.8186 23.6909C13.2428 23.8827 13.7033 23.9808 14.1688 23.9787C14.9283 23.9799 15.6647 23.7173 16.2521 23.2357C16.8395 23.7175 17.5757 23.9809 18.3354 23.9809C19.0952 23.9809 19.8314 23.7175 20.4188 23.2357C21.0061 23.7175 21.7424 23.9809 22.5021 23.9809C23.2618 23.9809 23.9981 23.7175 24.5854 23.2357C25.1728 23.7175 25.9091 23.9809 26.6688 23.9809C27.4285 23.9809 28.1647 23.7175 28.7521 23.2357C29.4078 23.774 30.2466 24.0372 31.0923 23.9699C31.938 23.9025 32.7246 23.5099 33.2868 22.8746C33.4964 22.6257 33.6119 22.3111 33.6132 21.9857V19.8398C33.6141 19.623 33.5641 19.4089 33.4674 19.2148ZM20.4188 19.9996V21.0551L19.8493 21.8051C19.6745 22.0434 19.4461 22.2371 19.1825 22.3707C18.9188 22.5042 18.6275 22.5738 18.332 22.5738C18.0365 22.5738 17.7451 22.5042 17.4815 22.3707C17.2179 22.2371 16.9894 22.0434 16.8146 21.8051L16.2521 21.0273V19.9996L18.0507 14.1662H21.1132L20.4188 19.9996ZM28.7521 21.0273L28.1896 21.8051C28.0148 22.0434 27.7863 22.2371 27.5227 22.3707C27.2591 22.5042 26.9678 22.5738 26.6723 22.5738C26.3767 22.5738 26.0854 22.5042 25.8218 22.3707C25.5582 22.2371 25.3297 22.0434 25.1549 21.8051L24.5854 21.0273V19.9996L23.891 14.1662H26.9813L28.7521 19.9996V21.0273Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7793_1330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(10.0004 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNewNotif);
export default __webpack_public_path__ + "static/media/ListNewNotif.d57958a1a35218bd599a56e0e50e013a.svg";
export { ForwardRef as ReactComponent };